import '@cosmos-web/cosmos-web/cosmos-web.css';
import '@cosmos-tokens/hotmart-product/base/css/_variables.css';
import '@cosmos/styles/base.css'
import '@cosmos/styles/theme.css'
import '@cosmos/button/variations/success.css'
import '@cosmos/form/form.css'
import '@cosmos/form/input-default.css'
import '@cosmos/styles/utilities/cursor.css'
import '@cosmos/styles/utilities/text/text.css'
import '@cosmos/styles/utilities/flex/flex.css'
import '@cosmos/styles/utilities/sizing/sizing.css'
import '@cosmos/styles/utilities/border/border.css'
import '@cosmos/styles/utilities/display/display.css'
import '@cosmos/styles/utilities/overflow/overflow.css'
import '@cosmos/styles/utilities/spacing/spacing.css'
import '@cosmos/styles/utilities/position/position.css'
import '@cosmos/styles/utilities/visibility.css'
import '@cosmos/styles/utilities/background/variations/grays.css'
import '@cosmos/styles/utilities/background/variations/green.css'
import '@cosmos/styles/utilities/border/variations/grays.css'

import { defineCustomElement as HcButton } from '@cosmos-web/components/hc-button';
import { defineCustomElement as HcFormField } from '@cosmos-web/components/hc-form-field';
import { defineCustomElement as HcH } from '@cosmos-web/components/hc-h';
import { defineCustomElement as HcP } from '@cosmos-web/components/hc-p';
import { defineCustomElement as HcAlert } from '@cosmos-web/components/hc-alert';

HcButton();
HcFormField();
HcH();
HcP();
HcAlert();